import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import SettingsSidebar from './settings/SettingsSidebar'
import ManageTasks from './settings/ManageTasks'
import Faqs from './settings/Faqs'
import AddTasks from './settings/AddTasks'
import Users from './Users'
import ChatSettings from './settings/ChatSettings';
import Organization from './settings/Organization';
import Subscription from './settings/Subscription';
import CreditHistory from './settings/CreditHistory';

const Settings = () => {
  const [selectedComponent, setSelectedComponent] = useState('tasks');
  const [showAddTask, setShowAddTask] = useState(false);
  const { data } = useSelector((state) => state.admin);
  
  const isAdmin = data?.user_role === 'ADMIN';
  const isSuperAdmin = data?.user_role === 'SUPER_ADMIN';

  // Ensure admin users can only access tasks component
  useEffect(() => {
    if (isAdmin && selectedComponent !== 'tasks') {
      setSelectedComponent('tasks');
    }
  }, [isAdmin, selectedComponent]);

  useEffect(() => {
    // Only block scroll for 'tasks', 'faqs', 'admin', 'organizations', 'subscriptions' when not in AddTasks (Overview/Standard Questions)
    const shouldBlockScroll = !showAddTask && ['tasks', 'faqs', 'admin', 'chat', 'organizations', 'subscriptions', 'credit-history'].includes(selectedComponent);
    if (shouldBlockScroll) {
      document.body.classList.add('block-scroll');
    } else {
      document.body.classList.remove('block-scroll');
    }
    return () => {
      document.body.classList.remove('block-scroll');
    };
  }, [selectedComponent, showAddTask]);

  if (showAddTask) {
    return (
      <div className='h-screen'>
        <AddTasks setShowAddTask={setShowAddTask} />
      </div>
    );
  }

  return (
    <div className="flex" style={{ height: 'calc(100vh - 50px)' }}>
      <div style={{ position: 'sticky', top: 0, height: '100vh', zIndex: 10 }}>
        <SettingsSidebar onSelect={setSelectedComponent} selectedComponent={selectedComponent} />
      </div>
      <div className='flex-grow p-4 overflow-y-auto' style={{ height: '100vh' }}>
        {selectedComponent === 'tasks' && <ManageTasks setShowAddTask={setShowAddTask} />}
        {isSuperAdmin && selectedComponent === 'faqs' && <Faqs />}
        {isSuperAdmin && selectedComponent === 'admin' && <Users />}
        {isSuperAdmin && selectedComponent === 'chat' && <ChatSettings />}
        {isSuperAdmin && selectedComponent === 'organizations' && <Organization />}
        {isSuperAdmin && selectedComponent === 'subscriptions' && <Subscription />}
        {isSuperAdmin && selectedComponent === 'credit-history' && <CreditHistory />}
      </div>
    </div>
  )
}

export default Settings 